import useMountEffect from '@restart/hooks/useMountEffect';
import { RiFocusLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import LevelHorizonModal from '@/components/modals/calibration/LevelHorizon';
import { modalManager } from '@/libs/ModalContainer';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modalManager.show(LevelHorizonModal, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Level Horizon';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiFocusLine;
Command.Panel = Panel;

export default Command;
